import React, { useState, useEffect, useRef } from "react";
import moment from "moment";

import TableHeader from "./TableHeader";
import AddToFavourite from "../../homepage/favourites/AddToFavourite";
import { endpoint, pages } from "../../common/constant";

import {
  createSuccessMsg,
  getCrctDropdown,
  initialFilters,
  structureList,
  updateSuccessMsg,
} from "./constants";
import TableContent from "./TableContent";
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { successToast } from "../../common/utils/methods/toasterFunctions/function";

import styles from "./phaseStyles.module.scss";

const PhaseConfiguration = () => {
  const listRef = useRef();

  const [dropdownLoader, setDropdownLoader] = useState(false);
  const [crctDropdown, setCrctDropdown] = useState([]);
  const [listApiLoader, setListApiLoader] = useState(false);
  const [filters, setFilters] = useState(initialFilters);

  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const fetchDropdown = async () => {
    setDropdownLoader(true);
    const res = await getCrctDropdown();
    setCrctDropdown(res);

    setDropdownLoader(false);
  };

  useEffect(() => {
    fetchDropdown();
  }, []);

  useEffect(() => {
    if (crctDropdown.length) fetchList();
  }, [crctDropdown, filters]);

  const fetchList = async (page = 0) => {
    setListApiLoader(true);

    const { phaseName, status, fromDate, toDate } = filters;

    const appliedFilters = {
      ...filters,
      ...(phaseName && {
        phaseName: typeof phaseName === "string" ? phaseName : phaseName.value,
      }),
      ...(status && { status: status.value }),
      ...(fromDate && { fromDate: moment(fromDate).format("YYYY-MM-DD") }),
      ...(toDate && { toDate: moment(toDate).format("YYYY-MM-DD") }),
    };

    const res = await fetchAllPostPromisedData(
      `${endpoint.phaseConfiguration.searchAcademicPhase}?offset=${page}`,
      appliedFilters,
      "post"
    );
    if (res?.code === 200) {
      setRowCount(res?.data?.totalRecords);

      const structuredList = structureList(
        crctDropdown,
        res?.data?.academicPhaseMasters
      );
      setRows(structuredList);
    } else {
      setRowCount(0);
      setRows([]);
    }

    setListApiLoader(false);
  };

  const createHandler = async (rowData) => {
    setListApiLoader(true);

    const res = await fetchAllPostPromisedData(
      endpoint?.phaseConfiguration.createAcademicPhase,
      rowData,
      "post"
    );
    if (res?.code === 200) {
      setPage(0);
      await fetchList(0);
      successToast(createSuccessMsg);
      listRef.current.stopEditing();
      setFilters(initialFilters);
    }

    setListApiLoader(false);
  };

  const updateHandler = async (rowData, rowId) => {
    setListApiLoader(true);

    const res = await fetchAllPostPromisedData(
      `${endpoint?.phaseConfiguration.updateAcademicPhase}/${rowId}`,
      rowData,
      "put"
    );
    if (res?.code === 200) {
      setPage(0);
      await fetchList(0);
      successToast(updateSuccessMsg);
      listRef.current.stopEditing();
      setListApiLoader(false);
      setFilters(initialFilters);
    }

    setListApiLoader(false);
  };

  const onPageChange = async (newPage) => {
    setPage(newPage);

    await fetchList(newPage);
  };

  const applyFilter = (filterPayload) => {
    listRef.current.stopEditing();

    setFilters(filterPayload);

    setPage(0);
  };

  return (
    <div>
      <header className="px-3">
        <AddToFavourite
          screenName={pages["phaseConfiguration"]["name"]}
          screenId={pages["phaseConfiguration"]["id"]}
          className="ml-auto"
          size="sm"
        />
      </header>
      <div className={`${styles["page-container"]}`}>
        <TableHeader
          listRef={listRef}
          crctDropdown={crctDropdown}
          filters={filters}
          applyFilter={applyFilter}
        />

        <TableContent
          ref={listRef}
          rows={rows}
          rowCount={rowCount}
          crctDropdown={crctDropdown}
          loader={listApiLoader || dropdownLoader}
          currentPage={page}
          onPageChange={onPageChange}
          createHandler={createHandler}
          updateHandler={updateHandler}
        />
      </div>
    </div>
  );
};

export default PhaseConfiguration;
